import script from "./kalio-group-meeting-sidebar-companies.vue?vue&type=script&setup=true&lang=js"
export * from "./kalio-group-meeting-sidebar-companies.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__